import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EnvironmentInjector,
  inject,
} from "@angular/core";
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";
import { LoadingService } from "./services/loading.service";
import { SharedService } from "./services/shared.service";
import { SystemService } from "./services/system.service";
import { TranslateService } from "@ngx-translate/core";
import { PushService } from "./visual-app/shared/services/push.service";

@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    imports: [IonApp, IonRouterOutlet],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent {
  public environmentInjector = inject(EnvironmentInjector);

  loading = false;

  constructor(
    public shared: SharedService,
    public loadingService: LoadingService,
    public system: SystemService,
    private translate: TranslateService,
    private push: PushService,
  ) {
    this.translate.addLangs(["pt", "en"]);
    this.translate.setDefaultLang("pt");
    this.translate.use("pt");
    this.limparDadosSensiveisLegados();
    this.initPlatforms();
  }

  /**
   * Versões antigas do app gravavam o cartão inteiro (número, CVV, CPF,
   * validade) em `paymentParams` no localStorage. Apaga em todo boot.
   */
  private limparDadosSensiveisLegados() {
    try {
      localStorage.removeItem("paymentParams");
    } catch {
      // storage indisponível (modo privado): nada a limpar
    }
  }

  async initLoading() {
    const loading = await this.system.loadingCtrl.create({});
    this.loadingService.loading$.subscribe((res) => {
      if (this.shared.web) {
        if (res) {
          loading.present();
        } else {
          loading.dismiss();
        }
      } else {
        this.loading = res;
      }
    });
  }

  initPlatforms() {
    this.shared.platform.ready().then(() => {
      if (this.shared.platform.is("mobile")) {
        this.shared.web = false;
        // Push notifications só no app nativo (no-op na web / navegador)
        this.push.init();
      } else {
        this.shared.web = true;
      }
      this.initLoading();
    });
  }
}
